const style = {
  green: '#1c943b',
};

export default style;



// WEBPACK FOOTER //
// ./src/utils/styles.js